export const APP_NAME = 'GOMARKE';

/** Sessão ativa — alinhado a GA4/Meta (3 h desde a última atividade). */
export const SESSION_TTL_MS = 3 * 60 * 60 * 1000;

/** Visitor persistente (localStorage + cookie). */
export const VISITOR_TTL_MS = 365 * 24 * 60 * 60 * 1000;
